import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11,6,1,0V12Z", style: {
  fillRule: "evenodd"
} }), /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, style: {
  fill: "none"
} }));
export default SvgArrow;
